enum HolderType {
	Undefined = 0,
	Individual = 1,
	Business = 2
}

export default HolderType;
